<template>
    <div class="table-responsive">
        <table class="table table-striped table-bordered mb-0">
            <thead>
            <tr>
                <th style="width: 70px">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="checkAll" name="checkAll"
                               v-on:click="checkAllEvent($event)"
                               v-model="checkAll">
                        <label class="custom-control-label" for="checkAll">All</label>
                    </div>
                </th>
                <th>Quote #</th>
                <th>Date Added</th>
                <th>Customer Name</th>
                <th>Status</th>
                <th>Item Name</th>
                <th>Added By</th>
            </tr>
            </thead>
            <template v-if="quotationData.quotations != null">
                <template v-for="(quotation, index) in quotationData.quotations.data">
                    <tr :id="quotation.id" v-on:click="selectQuotation(quotation, null)">
                        <td>
                            <div class="custom-control custom-checkbox">
                                <input :checked="selectedQuotations.includes(quotation.id)"
                                       v-on:click="selectQuotationCheckbox(quotation, $event)"
                                       type="checkbox" class="custom-control-input" :id="'quote_id' + quotation.id"
                                       name="quote_ids[]">
                                <label class="custom-control-label" :for="'quote_id' + quotation.id"></label>
                            </div>
                        </td>
                        <td>#{{ quotation.quotation_number }}</td>
                        <td>{{ quotation.quote_date }}</td>
                        <td>
                            {{ quotation.customer_data && quotation.customer_data.customer_contacts.length ? quotation.customer_data.company_name + ", " + quotation.customer_data.customer_contacts[0].contact_name : '' }}
                        </td>
                        <td>{{ quotation.status_details ? quotation.status_details.name : '' }}</td>
                        <td>{{ quotation.item_name }}</td>
                        <td>{{ quotation.added_data ? quotation.added_data.name : '' }}</td>
                    </tr>
                </template>

            </template>
        </table>

        <div class="btnrow text-left" v-if="quotationData.quotations != null && quotationData.quotations.data.length">
            <template>
                <div class="overflow-auto">
                    <b-pagination
                        v-model="current_page"
                        :total-rows="total"
                        :per-page="per_page"
                    ></b-pagination>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import {mapActions, mapGetters, mapState} from "vuex";

export default {
    name: "Quotations",
    props: ['selectedQuotations', 'search_filter', 'bus', 'customer_id'],
    created() {
        if (localStorage.getItem('token')) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        this.getQuotations();
    },
    mounted() {
        if (this.search_filter) {
            this.filterForm.search_filter = this.search_filter;
        }
        this.bus.$on('getQuotations', this.getQuotations)
    },
    data() {
        return {
            quotationData: {
                quotations: null,
                config: null,
            },
            current_page: 1,
            per_page: 10,
            total: 0,
            filterForm: {
                search_filter: null,
                status_filter: '1'
            },
            checkAll: false
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setQuotations',
            'setQuotationLoading'
        ]),
        checkAllEvent(event){
            this.quotationData.quotations.data.forEach((x) => {
                this.selectQuotation(x, event.target.checked);
            });
        },
        selectQuotationCheckbox(c, event){
            this.$emit('selectQuotation', {c: c.id, checked: event.target.checked});
        },
        selectQuotation(c, checked) {
            if(checked === null) {
                checked = !this.selectedQuotations.includes(c.id);
            }
            this.$emit('selectQuotation', {c: c.id, checked: checked});
        },
        getQuotations() {
            let self = this;
            this.setQuotationLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('quotations.index', {
                page:this.current_page,
                search_filter:this.filterForm.search_filter,
                customer_id: this.customer_id,
                so_sent_to_customer: true
            }), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        //console.log(data);
                        this.quotationData = data.data;
                        this.current_page = data.data.quotations.current_page;
                        this.per_page = data.data.quotations.per_page;
                        this.total = data.data.quotations.total;

                        if(this.checkAll) {
                            this.quotationData.quotations.data.forEach((x) => {
                                this.selectQuotation(x, true);
                            });
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setQuotationLoading(false);

                });
        },
        getSLNo(index) {
            return Number(this.quotationData.config['start_from']) + index;
        }
    },
    watch: {
        current_page: {
            handler: function (value) {
                if (value != 1) {
                    this.getQuotations();
                }
            }
        },
        search_filter: {
            handler: function (value) {
                this.filterForm.search_filter = value;
            }
        },
        /*checkAll: {
            handler: function (value) {
                if(value) {
                    this.quotationData.quotations.data.forEach((x) => {
                        this.selectQuotation(x, true);
                    });
                } else {
                    this.quotationData.quotations.data.forEach((x) => {
                        this.selectQuotation(x, false);
                    });
                }
            }
        },*/
        selectedQuotations: {
            handler: function (value) {
                if(value != null && this.quotationData.quotations.data != null && value.length == this.quotationData.quotations.data.length) {
                    this.checkAll = true;
                } else {
                    this.checkAll = false;
                }
            }
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
        ])
    }
}
</script>

<style scoped>

</style>
